import React,{useState,useEffect} from 'react'
import NavigationBar from '../components/nav';
import {Tabs,Tab,Container,Button} from 'react-bootstrap'
import Visit from '../components/Visit'
import NewVisit from './newVisit'
import app from '../login/firebase.js'
import Loading from '../components/utilities/loading/loading'
import ErrorPopup from "../components/utilities/errors/errorPopup"
import axios from 'axios'
import {Modal,Form,Alert,Row,Col} from "react-bootstrap"
import {Redirect} from 'react-router-dom'
import DateOfVisit from '../components/utilities/datePopup/date_edit';
import ReorderVisitsPopup from '../components/utilities/reorderVisitsPopup/ReorderVisitsPopup';

import Delete_Popup
 from '../components/utilities/deletePopup/deletePopup';

function RenameVisitPopup(props) {
    const [oldVisit, setOldVisit] = useState("")
    const [newVisit, setNewVisit] = useState("")
    const [error, setError] = useState(null)

    const canSubmit = oldVisit !== "" && newVisit !== "" && parseInt(newVisit) > 0

    const handleSubmit = () => {
        setError(null)
        props.onRename(parseInt(oldVisit), parseInt(newVisit), setError)
    }

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>Rename Visit</Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form.Group className="mb-3">
                    <Form.Label>Visit to rename</Form.Label>
                    <Form.Control as="select" value={oldVisit} onChange={e => setOldVisit(e.target.value)}>
                        <option value=""></option>
                        {Object.keys(props.data).sort((a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0])).map((v, i) => (
                            <option key={i} value={v.match(/\d+/)[0]}>{v}</option>
                        ))}
                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Label>New visit number</Form.Label>
                    <Form.Control
                        type="number"
                        min="1"
                        value={newVisit}
                        onChange={e => setNewVisit(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Cancel</Button>
                <Button variant="warning" onClick={handleSubmit} disabled={!canSubmit}>Rename</Button>
            </Modal.Footer>
        </Modal>
    )
}


function EditPopUp(props){
    const [val,setVal] = useState("")
    const onChange = (e) => {
        setVal(e.target.value)
    }
    useEffect(()=>{
        if (val!=""){
            setDisabled(false)
        }
        else{
            setDisabled(true)
        }
    },[val])
    const [disabled,setDisabled] = useState(true)
    const triggerEdit = (e) =>{
        props.triggerEdit(val)
    }
    return(
        <Modal show={props.showPopUp} onHide={props.hidePopup}>
                        <Modal.Header closeButton>Edit Mode</Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label>Select visit  to edit</Form.Label>
                                <Form.Control as={'select'} onChange={onChange}>
                                    <option></option>
                                    {Object.keys(props.data).sort((a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0])).map((v,i)=>(
                                        <option key={i}>{v}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant={'success'} onClick={triggerEdit} disabled={disabled}>Start editing</Button>
                        </Modal.Footer>
                    </Modal>

    )
}
class EditPatient extends React.Component{
    constructor(props){
        super(props)
        this.changeSubmitRef = React.createRef()
        this.visitDateRef = React.createRef()  // ref to date popup
        this.state = {
            data:null,
            isMounted:false,
            newVisit:null,
            updatedState:{},
            totalVisits:null,
            patientId:null,
            fetchLink:"",
            error:null,
            showPopUp:false,
            visitForEdit:null,
            redirect_to_home:false,
            showDelPopup:false,
            showDatePopup:false,
            showRenamePopup:false,
            showReorderPopup:false,
            navdate:"Not registered"
        }
        this.deletePatient = this.deletePatient.bind(this)
        this.handleDatePopup = this.handleDatePopup.bind(this)
        this.dateChange = this.dateChange.bind(this)
        

    }
    
   
    fetchData = async () => { //fetchin visit data from api 
       
        const p_id = this.props.match.params.id
        
        let func = this;
        var link = String(process.env.REACT_APP_editPatientURL)
        await app.auth().currentUser.getIdToken(true).then(async function(idToken){
        
            await axios.get(link,{
                headers:{'Content-Type': 'application/json','Accept': 'application/json','patient_id':p_id,'authorization':String(idToken),'Cache-Control': 'no-cache'}
            }).then( res=>{
                
                func.setState(prevState=>({
                                ...prevState,
                                data:res.data,
                                isMounted:true,
                                totalVisits:Object.keys(res.data).length,
                                patientId:p_id }))
                }
            ).catch(error=>{
                if(error.response){
                    func.setState({"error":error.response.data.message})
                }
                else if(error.request){
                    func.setState({"error":"Network Error"})
                }
                else{
                    func.setState({"error":" Error"})
                }
            })
        
    
    })}
     handleVisitUpdate = async () =>{ // function to update existing visit on database
       const  func = this;
        await app.auth().currentUser.getIdToken(true).then(async function(idToken){
          
            await axios.post(process.env.REACT_APP_editLink,(JSON.stringify(func.state.updatedState)),{
                headers:{'Content-Type': 'application/json','Accept': 'application/json',patient_id:func.state.patientId,'authorization':idToken,"visit":func.state.visitToUpdate}
            }).then( res=>{
                if(res.status == 200){
                     window.location.reload(false)
                }
                else{
                    alert(res.data)
                }
              
               
            }).catch(error=>{
                alert(error.response.data)
                    
                })
    })
    }
   
    showEditPopUp = ()=>{
        this.setState({"showPopUp":true}) // popup for edit mode
        
    }
    hidePopup = () =>{
        this.setState({"showPopUp":false})
    }
    startEdit= (visit) =>{
        this.setState({"visitForEdit":visit}) // triggers edit mode when changed .
        this.setState({"updatedState":this.state.data[visit]})
        this.setState({visitToUpdate:parseInt(visit.match(/\d+/)[0])})
        this.hidePopup()
    }
    showDeletePopup = () =>{
        this.setState({"showDelPopup":true})
    }
    hideDeletePopup = () =>{
        this.setState({"showDelPopup":false})
    }
    showRenamePopup = () => {
        this.setState({"showRenamePopup":true})
    }
    hideRenamePopup = () => {
        this.setState({"showRenamePopup":false})
    }
    showReorderPopup = () => {
        this.setState({"showReorderPopup":true})
    }
    hideReorderPopup = () => {
        this.setState({"showReorderPopup":false})
    }
    handleReorderVisits = async (mapping, setError) => {
        const func = this
        await app.auth().currentUser.getIdToken(true).then(async function(idToken) {
            await axios.post(process.env.REACT_APP_reorderVisitsURL,
                { mapping },
                { headers: { 'Content-Type': 'application/json', 'authorization': idToken, 'patient_id': func.state.patientId } }
            ).then(res => {
                if (res.status === 200) {
                    window.location.reload(false)
                }
            }).catch(error => {
                if (error.response) {
                    setError("Error " + error.response.status + ": " + (error.response.data || "Request failed."))
                } else {
                    setError("Network error: " + error.message)
                }
            })
        })
    }
    handleRenameVisit = async (oldVisit, newVisit, setError) => {
        const func = this
        await app.auth().currentUser.getIdToken(true).then(async function(idToken) {
            await axios.post(process.env.REACT_APP_renameVisitURL,
                { old_visit: oldVisit, new_visit: newVisit },
                { headers: { 'Content-Type': 'application/json', 'authorization': idToken, 'patient_id': func.state.patientId } }
            ).then(res => {
                if (res.status === 200) {
                    window.location.reload(false)
                }
            }).catch(error => {
                if (error.response) {
                    if (error.response.status === 409) {
                        setError("Visit " + newVisit + " already exists for this patient.")
                    } else {
                        setError("Error " + error.response.status + ": " + (error.response.data || "Request failed."))
                    }
                } else {
                    setError("Network error: " + error.message)
                }
            })
        })
    }
    updateEditVisit = async (visitData,visitNo) =>{ // function to fetch updated data when in edit mode
        
      await this.setState((prevState)=>({
            ...prevState,
            updatedState:visitData,
            visitToUpdate:visitNo
        }))
    }
    deletePatient(){
        // const navigate = useNavigate()
        const p_id = this.props.match.params.id
        let func = this;
        var link = String(process.env.REACT_APP_editPatientURL)
        app.auth().currentUser.getIdToken(true).then(async function(idToken){
        
            await axios.delete(link,{
                headers:{'Content-Type': 'application/json','Accept': 'application/json','patient_id':p_id,'authorization':idToken,'Cache-Control': 'no-cache'}
            }).then( res=>{
                
                // func.setState(prevState=>({
                //                 ...prevState,
                //                 data:res.data,
                //                 isMounted:true,
                //                 totalVisits:Object.keys(res.data).length,
                //                 patientId:p_id }))
                // }
                func.setState({"redirect_to_home":true})}
            ).catch(error=>{
                if(error.response){
                    func.setState({"error":error.response.data.message})
                }
                else if(error.request){
                    func.setState({"error":"Network Error"})
                }
                else{
                    func.setState({"error":" Error"})
                }
                alert(error.response.data)
            })
       
    
    })}
    componentDidUpdate(){
    }
    async componentDidMount(){
     
        // await fetch("settings.json").then(function(response){ // fetching links from setting json
        //               return response.json()
        //   }).then(  response=>  this.setState({fetchLink:response["editPatientURL"],"editLink":response['editLink']}))
        //   this.fetchData()
        await this.fetchData()
        if(this.state.data["Visit 1"].visits.length>0){
            this.setState((prevState)=>({
                ...prevState,
                navdate:this.state.data["Visit 1"].visits.date
            }))
        }
        else{
            this.setState((prevState)=>({
                ...prevState,
                navdate:"Not Registered"
            }))
        }

        
    }
    handleDatePopup(action){
        if (action == "show"){
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:true
                }
            ))
        }
        else {
            this.setState((prevState)=>(
                {
                    ...prevState,
                    showDatePopup:false,
                    // updatedState:{
                    //     ...prevState.updatedState,
                    //     visits:{}
                    // }
                    
                }
            ))
        }
    }
    dateChange(value){
        //  this.visitDateRef.current.handleChangeDirect("visits",event)
        // const {name,value} = event.target
        this.setState((prevState)=>({
            ...prevState,
            updatedState:{
                ...prevState.updatedState,
                visits:{
                    ...prevState.updatedState.visits,
                    date:value
                }
            }
        }))
    }
    setDisplayDate = (key) =>{
            if(this.state.data[key].visits.length>0){
                this.setState((prevState)=>({
                    ...prevState,
                    navdate:this.state.data[key].visits.date
                }))
            }
            else{
                this.setState((prevState)=>({
                    ...prevState,
                    navdate:"Not Registered"
                }))
            }
                // this.setState((prevState)=>({
                //     ...prevState,
                //     navdate:this.state.data[key].visits.date
                // }))
    }
    render(){
        if (!this.state.isMounted){
        return (
            <div>
                <NavigationBar/>
                {this.state.error ===null && <Loading/>}
                {this.state.error!==null && 
                <Container>
                    <Alert variant={'danger'}>Error</Alert>
                </Container>
                }
            </div>
            )

        }
        else{
            const data = this.state.data
            const sortedVisitKeys = Object.keys(data).sort((a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0]))
            const lastVisitKey = sortedVisitKeys[sortedVisitKeys.length - 1]
            const maxVisitNo = lastVisitKey ? parseInt(lastVisitKey.match(/\d+/)[0]) : 0
            const latestByDateKey = Object.keys(data).reduce((best, key) => {
                const d = data[key].visits && data[key].visits.date
                const bestD = best && data[best].visits && data[best].visits.date
                if (!d) return best
                if (!bestD) return key
                return new Date(d) > new Date(bestD) ? key : best
            }, lastVisitKey)

            return (
                <div>
                    <NavigationBar  patient_id={this.state.patientId}
                    newVisit={maxVisitNo + 1}
                    gender={this.state.data['Visit 1']['gender']}
                    dateOfDeath={this.state.data['Visit 1']['date_of_death']}
                    latestVisit={data[latestByDateKey]}
                    allVisits={this.state.data}
                    editPatient={true}
                    editMode={this.state.visitForEdit!=null?true:false}
                    editPopUp={this.showEditPopUp}
                    submit={this.handleVisitUpdate}
                    deletePatient={this.showDeletePopup}
                    renameVisit={this.showRenamePopup}
                    reorderVisits={this.showReorderPopup}
                    showDateDialog={this.handleDatePopup}
                    navDate={this.state.navdate}
                    />
                    <>
                    {/* <DateOfVisit show={this.state.showDatePopup} handleDatePopup={this.handleDatePopup} onChange={this.dateChange}/> */}

                    <EditPopUp showPopUp={this.state.showPopUp} hidePopup={this.hidePopup} triggerEdit={this.startEdit} data={this.state.data}/>
                    <RenameVisitPopup show={this.state.showRenamePopup} onHide={this.hideRenamePopup} onRename={this.handleRenameVisit} data={this.state.data}/>
                    <ReorderVisitsPopup show={this.state.showReorderPopup} onHide={this.hideReorderPopup} onReorder={this.handleReorderVisits} data={this.state.data}/>

                    {this.state.redirect_to_home && <Redirect to="/"/>}

                    <Delete_Popup show={this.state.showDelPopup} onHide={this.hideDeletePopup} onDelete={this.deletePatient} patient_id={this.props.match.params.id}/>
                    <Tabs defaultActiveKey={this.state.newVisit ==null?'Visit 1':'Visit '+this.state.newVisit} 
                    activeKey={this.state.visitForEdit!=null?this.state.visitForEdit:undefined}  >
                        {Object.keys(data).sort((a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0])).map((key,i)=>{
                            let visitRef = this.visitDateRef
                            var disableTabs = false;
                                if(this.state.visitForEdit!=null){
                                    disableTabs = (this.state.visitForEdit !== key)
                                }
                               var  date_of_visit;
                               if(Object.keys(data[key].visits).length>0){
                                      date_of_visit = " - " + this.state.data[key].visits.date

                               }
                               else{
                                    date_of_visit = ""
                               }
                            return (
                                <Tab eventKey={key} title={key + date_of_visit} key={i} disabled={this.state.visitForEdit!=null?disableTabs:false} mountOnEnter={true} unmountOnExit={false}>
                                <DateOfVisit show={this.state.showDatePopup} data={data[key].visits} 
                                handleDatePopup={this.handleDatePopup} onChange={this.dateChange}
                                     edit={true}
                                />

                                    <Visit ref={this.visitDateRef} handleVisitUpdate={this.updateEditVisit} data={data[key]} preventEdit={this.state.visitForEdit!=null?disableTabs:true} editURL={this.state.editLink}  visitName={key} visitNo={parseInt(key.match(/\d+/)[0])} patientID={this.props.match.params.id}/>
                                </Tab>
                            )
                        })}
                        {/* {this.state.newVisit!=null&&
                            <Tab eventKey={'Visit '+this.state.newVisit} title={'Visit '+this.state.newVisit}>
                                <NewVisit ref={this.changeSubmitRef} gender={this.state.data['Visit 1']['gender']} />
                            </Tab>
                        } */}
                    </Tabs>
                    </>
                    
                    
                </div>
            )
        }
        
    }
}

export default EditPatient